

 <nb-card class="modalCard" *ngIf="!loading && state === 'form'" >
           <nb-card-header>

 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{isEnglish ? 'Donate' : 'Подякувати автору?'}} </span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >

		<p style="margin-bottom:5px; font-size:16px;">{{isEnglish ? 'Enter donation amount' : 'Введіть суму доната' }}</p>
		<div><input nbInput  fullWidth [(ngModel)]="price" type="number" placeholder="" /> </div>
	 	<span  style="margin-top:5px; font-size:12px;">{{isEnglish ? 'Minimum 10 UAH' : 'Мінімальна сума донату 10 грн' }} </span>

		<div style="margin-top:15px; display:flex">
			<div style="margin-left:auto; display:flex">
			<button nbButton status="primary" [disabled]="!isPrice" (click)="pay()">
			{{isEnglish ? 'Go To Payment' : 'Перейти до оплати' }}</button>

			</div>
			</div>



        	</nb-card-body>
 </nb-card>


<!-- The bank's own payment page, framed. Everything that follows a card number
     being typed happens here; the modal only watches the order.

     Sized in viewport units rather than pixels: on a phone a fixed 640px frame
     plus a header and a footer does not fit, and the part that gets cut off is
     always the pay button. -->
 <nb-card class="payCard" *ngIf="state === 'paying'" >
           <nb-card-header>

 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{isEnglish ? 'Payment' : 'Оплата'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
		<nb-card-body class="payBody">


			<!-- Shown only when nothing has happened for a while. The two ways out it
			     offers both keep the buyer on this page. -->
			<div class="payHelp" *ngIf="showHelp">
				<div class="payHelpTitle">{{ isEnglish ? 'Payment not going through?' : 'Оплата не завершується?' }}</div>
				<p class="payHelpText">
					{{ isEnglish
						? 'Pay from the monobank app with mono Pay, or open the payment page in its own window — the order stays here either way.'
						: 'Оплатіть через mono Pay у застосунку monobank або відкрийте сторінку оплати в окремому вікні — замовлення залишиться тут.' }}
				</p>
				<a class="payHelpLink" href="javascript:;" (click)="openInWindow()">
					{{ isEnglish ? 'Open in a new window' : 'Відкрити в новому вікні' }}
				</a>
			</div>

			<iframe *ngIf="payUrl" [src]="payUrl" title="payment"
				[class.withHelp]="showHelp"
				class="payFrame"
				allow="payment *"></iframe>
		</nb-card-body>
		<nb-card-footer class="payFooter">
			<a href="javascript:;" *ngIf="!showHelp" (click)="openInWindow()">{{ isEnglish ? 'Open in a new window' : 'Відкрити в новому вікні'}}</a>
			<a href="javascript:;" class="footerBack" (click)="backToForm()">{{ isEnglish ? 'Back' : 'Назад'}}</a>
		</nb-card-footer>
 </nb-card>


 <nb-card class="modalCard" *ngIf="state === 'waiting'" >
           <nb-card-header>
 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{isEnglish ? 'Confirming payment' : 'Підтверджуємо оплату'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >
			 <div  style="display: flex; width:100%; margin-top:35px;">
			    <div style="display: flex; margin: auto;">
				 <app-loader></app-loader>
			     </div>
			    </div>
        	</nb-card-body>
 </nb-card>


 <nb-card class="modalCard" *ngIf="state === 'done'" >
           <nb-card-header>
 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{isEnglish ? 'Thank you!' : 'Дякуємо!'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >
		<div class="success-animation">
<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
</div>
		<p class="text-center" style="margin-top:15px;">{{isEnglish ? 'Your support has reached the author.' : 'Ваша подяка дійшла до автора.'}}</p>
        	</nb-card-body>
 </nb-card>


 <nb-card class="modalCard" *ngIf="state === 'failed'" >
           <nb-card-header>
 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{isEnglish ? 'Payment unavailable' : 'Оплата недоступна'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >
		<p class="text-center" style="margin-top:10px;">{{failMessage}}</p>
		<div style="margin-top:20px; display:flex">
			<div style="margin:auto; display:flex">
				<button nbButton status="default" (click)="closeMainModal()">{{isEnglish ? 'Close' : 'Закрити'}}</button>
			</div>
		</div>
        	</nb-card-body>
 </nb-card>


    <div *ngIf="loading" style=" position:fixed; z-index: 77771; width:100%; height:100%; top:0; left: 0; display: flex; ">
    <div style="display: flex; margin: auto;">

         <app-loader></app-loader>
     </div>
    </div>
